import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import VehicleRenewalStatus from "../components/vehicleRenewalStatus";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const Vehicle_position_entry_hire = () => {
  useAuthRedirect();
  const { sno } = useParams();

    const navigate = useNavigate();
   const [transfer, setTransfer] = useState({});
  
   useEffect(() => {
  const fetchTransfer = async () => {
    if (!sno) return;

    try {
      Swal.fire({
        title: "Loading Data",
        html: `
          <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
            <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
          </div>
          <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch details...</p>
        `,
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          const style = document.createElement("style");
          style.innerHTML = `
            @keyframes progressBar {
              0% { width: 0% }
              50% { width: 100% }
              100% { width: 0% }
            }
          `;
          document.head.appendChild(style);
        },
      });

      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/vehicle_transfer_details?sno=${sno}`);
      if (response.data && response.data.transferDetails?.length > 0) {
        const items = response.data.transferDetails;
        const transferDetail = {
          vcode: items[0].vehicle_code || "N/A",
          insertDate: items[0].insert_time || "N/A",
          vnumber: items[0].vehicle_number || "N/A",
          vname: items[0].vehicle_name || "N/A",
          vehicleBranch: items[0].branch_code || "N/A",
          vehicle_make: items[0].vehicle_make || "N/A",
          model: items[0].model || "N/A",
          vehicle_type: items[0].vehicle_type || "N/A",
          vehicle_basis: items[0].vehicle_basis || "N/A",
          chassis_num: items[0].chassis_num || "N/A",
          engine_SlNo: items[0].engine_SlNo || "N/A",
          vehicle_regdate: items[0].vehicle_regdate || "N/A",
          vehicle_regno: items[0].vehicle_regno || "N/A",
          purchase_date: items[0].purchase_date || "N/A",
          vehicle_purfrom: items[0].vehicle_purfrom || "N/A",
          Hypothecation: items[0].Hypothecation || "N/A",
          purchese_amt: items[0].purchese_amt || "N/A",
          insurance_date: items[0].insurance_date || "N/A",
          renewal_date: items[0].renewal_date || "N/A",
          insurance_number: items[0].insurance_number || "N/A",
          insurance_amt: items[0].insurance_amt || "N/A",
          premium_your: items[0].premium_your || "N/A",
          insurance_company: items[0].insurance_company || "N/A",
          Fc_date: items[0].Fc_date || "N/A",
          Fc_renewaldate: items[0].Fc_renewaldate || "N/A",
          rc_number: items[0].rc_number || "N/A",
          permit_expirydate: items[0].permit_expirydate || "N/A",
          permit_date: items[0].permit_date || "N/A",
          roadtax_to: items[0].roadtax_to || "N/A",
          roadtax_from: items[0].roadtax_from || "N/A",
          cumulative: items[0].cumulative || "N/A",
          vehicle_description: items[0].vehicle_description || "N/A",
          fld_equipment: items[0].fld_equipment || "N/A",
          fld_utilisation: items[0].fld_utilisation || "N/A",
          fld_vehiclecondition: items[0].fld_vehiclecondition || "N/A",
          remarks: items[0].remarks || "N/A",
        };

        setTransfer(transferDetail);
      }

      Swal.close();
    } catch (error) {
      Swal.close();
      console.error("Error fetching branches:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Unable to load data. Please try again.",
      });
    }
  };

  fetchTransfer();
}, [sno]);



  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <div className="back-div">
          <h2 className="add-txt">Vehicle Details - View</h2>
         <button
        onClick={() => navigate(-1)}
        className="back-button"
        
      >
        <i className="fa-solid fa-arrow-left"></i> Back
      </button>
          </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form">
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="vcode" value={transfer.vcode} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Entry Date :</label>
                <input type="text" value={new Date(transfer.insertDate).toLocaleDateString()} readOnly={true} />
              </div>
            </div>

            
            <div className="form-row">
              <div className="form-group">
                <label>Branch Name :</label>
                <input type="text" name="branch" value={transfer.vehicleBranch} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Status :</label>
                <input type="text" name="driver" value="Own"   readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Name :</label>
                <input type="text" name="vname" value={transfer.vname} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Number :</label>
                <input type="text" name="vehno" value={transfer.vnumber} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Make :</label>
                <input type="text" name="vname" value={transfer.vehicle_make} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Model :</label>
                <input type="text" name="vehno" value={transfer.model} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Type:</label>
                <input type="text" name="vname" value={transfer.vehicle_type} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Basis :</label>
                <input type="text" name="vehno" value={transfer.vehicle_basis} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Chassis Number:</label>
                <input type="text" name="vname" value={transfer.chassis_num} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Engine SL.No :</label>
                <input type="text" name="vehno" value={transfer.engine_SlNo} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Reg Number:</label>
                <input type="text" name="vname" value={transfer.vehicle_regno} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Reg date:</label>
                <input type="text" name="vname" value={ transfer.vehicle_regdate ? new Date(transfer.vehicle_regdate).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Purchased From:</label>
                <input type="text" name="vname" value={transfer.vehicle_purfrom} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Purchased date:</label>
                <input type="text" name="vname" value={ transfer.purchase_date ? new Date(transfer.purchase_date).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Hypothecation with:</label>
                <input type="text" name="vname" value={transfer.Hypothecation} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Purchased Amount:</label>
                <input type="text" name="vehno" value={transfer.purchese_amt} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Hypothecation with:</label>
                <input type="text" name="vname" value={transfer.Hypothecation} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Purchased Amount:</label>
                <input type="text" name="vehno" value={transfer.purchese_amt} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Insurance date:</label>
                  <input type="text" name="vname" value={ transfer.insurance_date ? new Date(transfer.insurance_date).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
              <div className="form-group">
                <VehicleRenewalStatus renewalDate={transfer.renewal_date} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Insurance Number:</label>
                <input type="text" name="vname" value={transfer.insurance_number} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Insured amount:</label>
                <input type="text" name="vehno" value={transfer.insurance_amt} readOnly={true} />
              </div>
            </div>  

            <div className="form-row">
              <div className="form-group">
                <label>Insurance Premium <br></br>Per Year:</label>
                <input type="text" name="vname" value={transfer.premium_your} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Insurance Company:</label>
                <input type="text" name="vehno" value={transfer.insurance_company} readOnly={true} />
              </div>
            </div> 

           

            <div className="form-row">
              <div className="form-group">
                <label>FC Date:</label>
                <input type="text" name="vname" value={ transfer.Fc_date ? new Date(transfer.Fc_date).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
              <div className="form-group">
                <VehicleRenewalStatus renewalDate={transfer.Fc_renewaldate} />
              </div>
            </div> 

            <div className="form-row">
              <div className="form-group">
                <label>RC Book Number:</label>
                <input type="text" name="vname" value={transfer.rc_number} readOnly={true} />
              </div>
              <div className="form-group">
                <VehicleRenewalStatus renewalDate={transfer.permit_expirydate} />
              </div>
            </div> 

            <div className="form-row">
              <div className="form-group">
                <label>Permit date:</label>
                <input type="text" name="vname" value={ transfer.permit_date ? new Date(transfer.permit_date).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
              <div className="form-group">
                <label>Road Tax To Date:</label>
                <input type="text" name="vname" value={ transfer.roadtax_to ? new Date(transfer.roadtax_to).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
            </div> 

            <div className="form-row">
              <div className="form-group">
                <label>Road Tax From Date:</label>
                <input type="text" name="vname" value={ transfer.roadtax_from ? new Date(transfer.roadtax_from).toLocaleDateString('en-GB') : ''}readOnly={true}/>
              </div>
              <div className="form-group">
                <label>Last updated H M R:</label>
                <input type="text" name="vname" value={transfer.cumulative} readOnly={true} />
              </div>
            </div> 

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle description:</label>
                <input type="text" name="vname" value={transfer.vehicle_description} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Equipment:</label>
                <input type="text" name="vname" value={transfer.fld_equipment} readOnly={true} />
              </div>
            </div> 

            <div className="form-row">
              <div className="form-group">
                <label>Utilisation:</label>
                <input type="text" name="vname" value={transfer.fld_utilisation} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Condition:</label>
                <input type="text" name="vname" value={transfer.fld_vehiclecondition} readOnly={true} />
              </div>
            </div> 

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="vname" value={transfer.remarks} readOnly={true} />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden"  />
              </div>
            </div> 
          </form>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_position_entry_hire;
